export const SET_FACILITIES = 'SET_FACILITIES';
export const SET_FACILITIES_LOADING = 'SET_FACILITIES_LOADING';
export const SET_EXPAND_ALL = 'SET_EXPAND_ALL';
export const SET_SELECTED_ROOMS = 'SET_SELECTED_ROOMS';
export const SET_SELECTED_FACILITIES = 'SET_SELECTED_FACILITIES';